<div fxLayout="column" fxLayoutAlign="start" *screenResource="['DOSSIER', 'READ']">
  <div class="page-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
    <div fxFlex class="mat-display-1 page-title">VLOK Uitzonderingen</div>
    
    <div fxFlex fxLayoutAlign="end center">
      <button type="button" (click)="resyncAll()" mat-raised-button color="primary">
        <mat-icon>refresh</mat-icon>
        Alle opnieuw synchroniseren
      </button>
    </div>
  </div>

  <div class="page-content">
    <div class="table-responsive" *appSkeletonLoader="{ loading: loading, amountOfRows: 10, height: '32px', minWidth:'20%', maxWidth: '90%' }">
      <table fxFlexFill mat-table [dataSource]="dataSource" matSort matSortActive="PaCode" matSortDirection="asc">
        <ng-container matColumnDef="PaCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>PA-code</th>
          <td mat-cell *matCellDef="let entry">{{ entry.PaCode }}</td>
        </ng-container>
        <ng-container matColumnDef="EnCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>EN-code</th>
          <td mat-cell *matCellDef="let entry">{{ entry.EnCode ? entry.EnCode : "-" }}</td>
        </ng-container>
        <ng-container matColumnDef="BuildingCode">
          <th mat-header-cell *matHeaderCellDef>Dossier</th>
          <td mat-cell *matCellDef="let entry">
            <ng-container *ngIf="entry.BuildingCode; else noBuildingCode">
              <a [href]="'/dossiers/' + entry.BuildingCode" target="_blank">{{ entry.BuildingCode }}</a>
            </ng-container>

            <ng-template #noBuildingCode>
              -
            </ng-template>            
          </td>
        </ng-container>
        <ng-container matColumnDef="Address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Adres</th>
          <td mat-cell *matCellDef="let entry">{{ entry.Address ? entry.Address : "-" }}</td>
        </ng-container>
        <ng-container matColumnDef="Reason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Reden</th>
          <td mat-cell *matCellDef="let entry">{{ entry.Reason }}</td>
        </ng-container>
        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef class="actions"></th>
          <td mat-cell *matCellDef="let entry">
            <div fxLayout="row" fxLayoutAlign="end center">
              <button type="button" mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <ng-container *screenResource="['DOSSIER', 'UPDATE']">
                  <button mat-menu-item type="button" (click)="resyncItem(entry)">
                    <mat-icon>refresh</mat-icon>
                    <span>Opnieuw synchroniseren</span>
                  </button>

                  <button mat-menu-item type="button" (click)="deleteItem(entry)">
                    <mat-icon>cancel</mat-icon>
                    <span>Verwijderen</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr 
          mat-row
          *matRowDef="let entry; columns: displayedColumns"
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td *ngIf="loading" class="mat-cell" [attr.colspan]="displayedColumns.length">Laden...</td>
          <td *ngIf="!loading" class="mat-cell" [attr.colspan]="displayedColumns.length">Geen gegevens gevonden.</td>
        </tr>
      </table>
      <mat-paginator [style.display]="loading ? 'none' : 'unset'" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
